import { render, staticRenderFns } from "./hetongbuy.vue?vue&type=template&id=6fe57c22"
import script from "./hetongbuy.vue?vue&type=script&lang=js"
export * from "./hetongbuy.vue?vue&type=script&lang=js"
import style0 from "./hetongbuy.vue?vue&type=style&index=0&id=6fe57c22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports